import { render, staticRenderFns } from "./agentConfig.vue?vue&type=template&id=4537d831&"
import script from "./agentConfig.vue?vue&type=script&lang=ts&"
export * from "./agentConfig.vue?vue&type=script&lang=ts&"
import style0 from "./agentConfig.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports